module.exports = __webpack_public_path__ + "frontend/img/icon-result-gt-50.036115f0.svg";